<template>
  <v-row
    justify="center">
    <v-col
      cols="auto"
      md=8
      sm=10
      >
      <v-card
        class="main--text">
        <v-form>
          <v-container
            fluid
            glid-list-md>
            <v-row v-if="errors.length">
              <ul>
                <li
                  v-for="(error, index) in errors"
                  :key="index"
                  class="font-weight-bold red--text">{{error}}</li>
              </ul>
            </v-row>
            <v-row
              align="center">
              <v-col
                class="font-weight-bold subheading"
                >新規ユーザー情報入力フォーム</v-col></v-row>
            <v-row
              dense
            >
              <v-col
                cols="auto"
                md=6
                sm=6>
                <v-text-field
                  v-model="familyName"
                  label="姓"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="familyName"
                  data-vv-as="名字"
                  required
                  :error-messages="errors.collect('familyName')"
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="auto"
                md=6
                sm=6>
                <v-text-field
                  v-model="personalName"
                  label="名"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="personalName"
                  data-vv-as="名前"
                  required
                  :error-messages="errors.collect('personalName')"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              dense
              >
              <v-col
                cols="auto"
                md=6
                sm=6>
              <v-text-field
                v-model="flatFamilyName"
                label="セイ"
                type="text"
                v-validate="'required'"
                data-vv-name="flatFamilyName"
                data-vv-as="名字（カナ）"
                required
                :error-messages="errors.collect('flatFamilyName')"
              >
              </v-text-field>
              </v-col>
              <v-col
                cols="auto"
                md=6
                sm=6>
              <v-text-field
                v-model="flatPersonalName"
                label="メイ"
                type="text"
                v-validate="'required'"
                data-vv-name="flatPersonalName"
                data-vv-as="名前（カナ）"
                required
                :error-messages="errors.collect('flatPersonalName')"
              >
              </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group
                  v-model="gender"
                  row
                  v-validate="'required'"
                  data-vv-name="gender"
                  data-vv-as="性別"
                  required
                  :error-messages="errors.collect('gender')"
                  >
                  <v-radio
                    label="男性"
                    value="male">
                  </v-radio>
                  <v-radio
                    label="女性"
                    value="female">
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                md=6>
                <v-menu
                  ref="birthdayMenu"
                  v-model="birthdayMenu"
                  :close-on-content-click="false"
                  :return-value.sync="stringBirthday"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="stringBirthday"
                      label="生年月日"
                      prepend-icon="event"
                      v-on="on"
                      v-validate="'required'"
                      data-vv-name="birthday"
                      data-vv-as="生年月日"
                      required>
                    </v-text-field>
                  </template>
                    <v-date-picker
                      v-model="stringBirthday"
                      no-title
                      scrollable
                      width="360">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="birthdayMenu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.birthdayMenu.save(stringBirthday)">OK</v-btn>
                    </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row
            dense
            >
            <v-col
              md=6
              >
              <v-text-field
                v-model="phone"
                label="電話番号(ハイフンなし)"
                type="text"
                v-validate="'required|numeric'"
                data-vv-name="phone"
                data-vv-as="電話番号"
                required
                :error-messages="errors.collect('phone')"
                >
              </v-text-field>
              </v-col>
            </v-row>
            <v-row
              dense
            >
              <v-col
              md=6>
                <v-text-field
                  v-model="postalCode"
                  label="郵便番号(ハイフンなし７ケタ)"
                  type="text"
                  v-validate="'required|numeric'"
                  data-vv-name="postalCode"
                  data-vv-as="郵便番号"
                  required
                  :error-messages="errors.collect('postalCode')"
                  >
                </v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  rounded
                  outlined
                  color="primary"
                  @click="$emit('address-button-click')">
                  住所検索</v-btn>
              </v-col>
            </v-row>
            <v-row
              dense>
              <v-col
                md=6>
                <v-select
                  v-model="prefecture"
                  label="都道府県"
                  type="text"
                  :items="prefectures"
                  v-validate="'required'"
                  data-vv-name="prefecture"
                  data-vv-as="都道府県"
                  required
                  :error-messages="errors.collect('prefecture')"
                  >
                </v-select>
              </v-col>
              <v-col
                md=6>
                <v-text-field
                  v-model="municipality"
                  label="市区町村"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="municipality"
                  data-vv-as="市区町村"
                  required
                  :error-messages="errors.collect('municipality')"
                  >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                md=12>
                <v-text-field
                  v-model="subAddress"
                  label="下位住所（丁目番地以下）"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="subAddress"
                  data-vv-as="下位住所"
                  required
                  :error-messages="errors.collect('subAddress')"
                  >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
              md=6>
                <v-text-field
                  v-model="nearestStation"
                  label="最寄り駅（任意入力）"
                  type="text">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              >
              <v-col
              cols=12
                class="body-1 grey--text text--darken-2"
                >お支払い情報
              </v-col>
              <v-col>
                <VueCardPayment
                  v-model="creditCard"
                  :settings="{
                    labels:{
                      cardNumber: 'カード番号',
                      month: '月',
                      year: '年',
                      cardHolder: 'カード名義',
                      button: '確認'
                    },
                    placeholders: {
                      cardNumber: '0000 0000 0000 0000',
                      month: '00',
                      year: '00',
                      cardHolder: 'TARO MIKENEKO',
                      cvv: '000'
                    },
                    showBank: true,
                    showPaymentSystem: true
                  }"
                  @card-submit="registerCardInfo"/>
              </v-col>
            </v-row>
            <v-row
              justify="end"
              >
              <v-col>
                <v-btn
                  rounded
                  outlined
                  color="primary"
                  @click="submit()"
                  >登録
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-profile-setting-finished-dialog
          :enable="dialog"
          @break-button-click="toMyPage"
          @continue-button-click="toStudentProfileSetting"
        />
        <v-dialog
          :value="errDialog"
          persistent
          width="400">
          <v-card>
            <v-container
              fluid
              grid-list-md>
              <v-row
                justify-center>
                <v-col>
                  {{ errMessage }}
                </v-col>
              </v-row>
              <v-row
                justify-center>
                <v-btn
                  rounded
                  depressed
                  outlined
                  color="primary"
                  @click="errDialog=false"
                  >
                  OK
                  </v-btn>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
import VProfileSettingFinishedDialog from "@/components/organisms/parent/VProfileSettingFinishedDialog.vue"
import { prefectures } from '@/models/Regions'

export default {
  components: {
    VProfileSettingFinishedDialog
  },
  props: {
    value: Object
  },
  data() {
    return {
      birthdayMenu: null,
      repo: null,
      dialog: false,
      prefectures: prefectures,
      creditCard: {},
      errMessage: "",
      errDialog: false
    }
  },
  methods: {
    submit: function() {
      this.$validator.validateAll().then((result) => {
        if (result && this.value.cardId) {
          this.$emit("submit-button-click")
          this.dialog = true
        }
        else if (!(this.value.cardId)){
          this.errMessage = "カード情報を確認してください"
          this.errDialog = true
        }
      })
    },
    birthdayToString() {
      const t = this.birthday.getFullYear()
      const m = this.birthday.getMonth() + 1
      const d = this.birthday.getDate()
      return t + "-" + m + "-" + d
    },
    toMyPage() {
      this.$router.push({name: "students", params: {id: this.$store.getters.parent.uuid}})
    },
    toStudentProfileSetting() {
      this.$router.push({name: "studentProfileSetting", params: {id: this.$store.getters.parent.uuid}})
    },
    updateValue: function (diff) {
      this.$emit("input", { ...this.value, ...diff })
    },
    async registerCardInfo(){
      this.$emit('card-button-click', this.creditCard)
    }
  },
  computed: {
    personalName: {
      get() {
        return this.value.personalName
      },
      set(personalName) {
        this.updateValue({ personalName })
      }
    },
    familyName: {
      get() {
        return this.value.familyName
      },
      set(familyName) {
        this.updateValue({ familyName })
      }
    },
    flatPersonalName:{
      get() {
        return this.value.flatPersonalName
      },
      set(flatPersonalName) {
        this.updateValue({ flatPersonalName })
      }
    },
    flatFamilyName: {
      get() {
        return this.value.flatFamilyName
      },
      set(flatFamilyName) {
        this.updateValue({ flatFamilyName})
      }
    },
    gender: {
      get() {
        return this.value.gender
      },
      set(gender) {
        this.updateValue({ gender })
      }
    },
    birthday: {
      get() {
        return this.value.birthday
      },
      set(birthday) {
        this.updateValue({ birthday })
      }
    },
    stringBirthday: {
      get () {
        return this.birthdayToString()
      },
      set (stringBirthday) {
        this.birthday = new Date(stringBirthday)
      }
    },
    phone: {
      get() {
        return this.value.phone
      },
      set(phone) {
        this.updateValue({ phone })
      }
    },
    postalCode: {
      get() {
        return this.value.postalCode
      },
      set(postalCode) {
        this.updateValue({ postalCode })
      }
    },
    prefecture: {
      get() {
        return this.value.prefecture
      },
      set(prefecture) {
        this.updateValue({ prefecture })
      }
    },
    municipality: {
      get() {
        return this.value.municipality
      },
      set(municipality) {
        this.updateValue({ municipality })
      }
    },
    subAddress: {
      get() {
        return this.value.subAddress
      },
      set(subAddress) {
        this.updateValue({ subAddress })
      }
    },
    nearestStation: {
      get() {
        return this.value.nearestStation
      },
      set(nearestStation) {
        this.updateValue({ nearestStation })
      }
    }
  }
}
</script>

<style scoped>
.error-message {
  color: red
}
</style>